/* eslint-disable no-underscore-dangle */

const SiteBadgeAPI = require('../utils/SiteBadgeAPI');
const WysiwygUtils = require('./launcher/util/listbuilder/wysiwyg/util');

const managePageUrl = process.env.CLIENT_MANAGE_URL;
const apiUrl = process.env.CLIENT_API_URL;
const staticUrl = process.env.CLIENT_STATIC_URL;
const thumbsUrl = 'https://thumbs.sumome.com';
const microSumoUrl = 'microsumome.b-cdn.net';

// Parse the domain from the apiUrl
let domainVar = apiUrl;
if (domainVar.indexOf('https://') === 0) {
  domainVar = domainVar.substring(8);
} else if (domainVar.indexOf('http://') === 0) {
  domainVar = domainVar.substring(7);
} else if (domainVar.indexOf('//') === 0) {
  domainVar = domainVar.substring(2);
}
if (domainVar.split('.').length > 2) {
  domainVar = domainVar.substring(domainVar.indexOf('.'));
}

// Apps that are installed on everyone's site.
const SETTINGS_APP_ID = '5d26e2da-aef5-41c1-947a-624497281723';
const IMAGE_SHARER_APP_ID = '55c989d5-855d-4538-b67b-3cdb46acd968';
const SHARE_APP_ID = '9e8a4d2a-6f8c-415e-851b-bdfe4c01d5c1';
const NOTIFICATIONS_APP_ID = 'ee27a0af-9947-40c9-8eab-0ab6a4f7a9c1';

const queryStringParser = (str) => {
  if (!str) return {};

  const queryString = str.substr(1).split('&');
  if (queryString === '') return {};

  const queryDict = {};
  for (let i = 0; i < queryString.length; i += 1) {
    const p = queryString[i].split('=', 2);

    if (p.length === 1) {
      queryDict[p[0]] = '';
    } else {
      try {
        queryDict[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '));
      } catch (e) {
        queryDict[p[0]] = p[1].replace(/\+/g, ' ');
      }
    }
  }

  return queryDict;
};

const isWebpackBuild = (typeof __webpack_require__ === 'function');

define([
  'js-cookie',
  'scaleapp',
  'articles',
  'base64url',
  'es6!sumo/util',
  'es6!sumo/util/Shopify',
  'es6!launcher/util/listbuilder/embedded/util',
  'URI',
  (isWebpackBuild ? './webpackSumoRequireShim' : './emptyShim'), // eslint-disable-line camelcase
], function loadedDeps(
  jscookie, sa, Articles,
  base64url, Util, ShopifyUtil, EmbeddedUtil, URI,
) {
  const { Constants: { CLIENT_MODES }} = Util;

  if (isWebpackBuild) {
    window.sumo = arguments[arguments.length - 1]; // eslint-disable-line prefer-rest-params
  }

  const apiFetch = async (url, options) => {
    const token = jscookie.get('__smToken');
    const headers = {
      'Content-Type': 'application/json',
      ...(options?.headers || {}),
      ...(token ? { 'X-Sumo-Auth': token } : {}),
    };
    const requestOptions = {
      ...options,
      credentials: 'omit',
      headers,
      method: options.method || 'POST',
    };
    const response = await fetch(url, requestOptions);

    return response.json();
  };

  let loaded = false;
  let siteId = document.querySelector('script[data-sumo-site-id]')?.getAttribute('data-sumo-site-id');
  const siteVisitorIdCookie = `__smVID:${siteId}`;
  const visitorIdCookie = '__smVID';
  const sumoMode = document.querySelector('script[data-sumo-mode]')?.getAttribute('data-sumo-mode') || '';
  const appRenderMode = document.querySelector('script[app-render-mode]')?.getAttribute('app-render-mode') || '';

  const siteRegistered = false;
  const hasSumoMePro = false;
  const sumoPlatform = document.querySelector('script[data-sumo-platform]')?.getAttribute('data-sumo-platform');
  let currentApp = null;
  let sumoBadge = null;
  const sessionId = jscookie.get('__smToken') || null;
  // we only ran with siteID cookies for a few days but lets pull those in for backwards compat.
  const siteVisitorId = jscookie.get(siteVisitorIdCookie) || null;
  const visitorId = jscookie.get(visitorIdCookie) || siteVisitorId || WysiwygUtils.genId();
  let softLogin = false;
  const appQueue = [];
  let launcherLaunched = false;
  let startingApp = false;
  let deferredWidgets = [];

  const sumoProperties = {
    oldSumoUrl: apiUrl,
    secureOldSumoUrl: apiUrl,
    sumoUrl: apiUrl,
    secureSumoUrl: apiUrl,
    domain: domainVar,
    baseUrl: staticUrl.endsWith('/') ? staticUrl : `${staticUrl}/`,
    thumbsUrl,
    microSumoUrl,
    siteId,
    siteRegistered,
    hasSumoMePro,
    sessionId,
    badgeLocation: 'hidden',
    user: null,
    visitorId,
    environment: 'prod',
    // Installed apps
    apps: [],
    // All apps that are public including core and deprecated.
    publicApps: [],
    yield: false,
    mode: sumoMode,
    appRenderMode,
    platform: sumoPlatform,
    clientSites: { currentSite: {}, siteList: [] },
  };

  if (siteVisitorId) jscookie.remove(siteVisitorIdCookie);
  jscookie.set(visitorIdCookie, sumoProperties.visitorId, { expires: 30 });

  const handleBadgeClick = () => {
    if (currentApp === 'login') {
      core.emit('stop', `${currentApp}/app`, () => {
        core.emit('startApp', 'login');
      });

      return;
    }

    const alwaysSoftLogin = !sumoProperties.siteRegistered && ((sumoMode === CLIENT_MODES.ADMIN && sumoPlatform !== 'wordpress-endurance') || hint);

    if (alwaysSoftLogin || softLogin) {
      apiFetch(`${apiUrl}/api/softlogin`, {
        body: JSON.stringify({ site_id: siteId })
      });

      core.emit('beforeLogin');

      for (let i = 0; i < deferredWidgets.length; i += 1) {
        core.emit('startWidget', deferredWidgets[i]);
      }

      core.emit('startApp', 'control');
    } else {
      core.emit('startApp', 'login');
    }
  };

  const installSiteBadge = (hint) => {
    SiteBadgeAPI.install({
      location: sumoProperties.badgeLocation,
      baseUrl: sumoProperties.baseUrl,
      currentApp,
      hint,
      onClick: handleBadgeClick,
    });
  };

  const SumoSandbox = function createSandbox(core, instanceId, options, moduleId) {
    core._mediator.installTo(this);

    this.id = instanceId;

    this.properties = sumoProperties;

    this.close = () => {
      core.on(`${moduleId}/stopped`, () => {
        core.off(`${moduleId}/stopped`);
        core.emit(`${moduleId}/closed`, moduleId);
      });
      this.emit('stop', moduleId);
    };

    return this;
  };
  const core = new sa.Core(SumoSandbox);

  if ('__smReady' in window && typeof window.__smReady === 'function') {
    window.__smReady({ core });
  }

  core.on('startService', (appId) => {
    if (sumoMode !== CLIENT_MODES.ADMIN && sumoMode !== CLIENT_MODES.MANAGE) {
      const moduleId = `${appId}/service`;

      // eslint-disable-next-line no-undef
      sumo.require([moduleId], (module) => {
        core.register(moduleId, module);
        core.start(moduleId, () => {
          core.emit(`${moduleId}/started`, moduleId);
        });
      });
    }
  });

  core.on('startWidget', (appId) => {
    if (sumoMode === CLIENT_MODES.MANAGE) return;
    if (sumoMode !== CLIENT_MODES.ADMIN) {
      const moduleId = `${appId}/widget`;

      // eslint-disable-next-line no-undef
      sumo.require([moduleId], (module) => {
        core.register(moduleId, module);
        core.start(moduleId, {
          options: {
            sumoProperties,
          },
        }, () => {
          core.emit(`${moduleId}/started`, moduleId);
        });
      });
    }
  });

  function startApp(appId, opts) {
    if (appId === SETTINGS_APP_ID) {
      core.emit('openManagePage', { sumopath: 'settings' });
    } else if (appId === NOTIFICATIONS_APP_ID) {
      core.emit('openManagePage', { sumopath: 'notifications' });
    } else if (appId === 'app_store') {
      core.emit('openManagePage', { sumopath: 'app_store' });
    }

    const moduleId = `${appId}/app`;

    if (
      (appId === 'app_store' || appId === SETTINGS_APP_ID)
      && !launcherLaunched && sumoMode !== CLIENT_MODES.MANAGE
    ) {
      core.emit('openManagePage', { sumopath: 'settings' });
    }

    startingApp = true;
    // eslint-disable-next-line no-undef
    sumo.require([moduleId], (module) => {
      if (moduleId === 'launcher/app' && launcherLaunched) return;

      core.register(moduleId, module);

      const config = { options: opts || {} };
      config.options.sumoProperties = sumoProperties;
      core.start(moduleId, config, (err) => {
        startingApp = false;

        core.off(`${moduleId}/closed`);
        core.emit(`${moduleId}/started`, moduleId);

        if (!err) {
          // If current app running close it
          if (currentApp) {
            core.emit('stop', `${currentApp}/app`, () => { });
          }

          if (appId === 'launcher') {
            launcherLaunched = true;
          } else {
            currentApp = appId;
          }
        } else {
          console.log(`Failed to start, ${moduleId}`);
          console.log(err);
        }

        // Start apps put on the queue until there aren't anymore left.  appQueue is almost
        // always empty except when a user needs to login, an app is already being started, etc.
        if (appId !== 'login' && appQueue.length > 0) {
          const app = appQueue.shift();
          core.emit('startApp', app);
        }
      });
    }, (err) => {
      console.log('module load error:', err);
      startApp(SETTINGS_APP_ID, opts);
    });
  }

  function installApp(appId, done) {
    if (!appId) return;

    apiFetch(`${sumoProperties.sumoUrl}/api/app_store/install`, {
      body: JSON.stringify({ site_id: sumoProperties.siteId, app_id: appId })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        const status = data.site_app.status;
        const name = data.app.name;
        let error = null;

        if (status === 'deprecated') error = new Error(`${name} is no longer available.`);

        core.emit('setProperties', { apps: data.apps, services: data.services, widgets: data.widgets });
        // Always reload apps after install.
        core.emit('reloadApps');

        return done(error);
      } else if (data.message) {
        return done(new Error(data.message));
      }
    });
  }

  let isWindowFocused = true;
  let managePageWin = null;

  const onFocus = () => {
    Util.removeEvent(window, 'focus', onFocus);
    isWindowFocused = true;
  };

  core.on('openManagePage', (opts = {}) => {
    const { sumopath = '' } = opts;

    // Don't start popping open tabs if Sumo isn't active
    if (!isWindowFocused || sumoMode === CLIENT_MODES.MANAGE) return;

    const { magicPassword } = sumoProperties;
    const queryString = magicPassword ? `?sumo_m_pw=${magicPassword}` : '';

    const open = () => {
      managePageWin = window.open(`${managePageUrl}/site/${siteId}/manage/${queryString}#/${sumopath}`, 'sumo_manage');
    };

    const close = () => { managePageWin.close(); };

    // We have to close the original window first because firefox doesn't auto switch to the new tab
    if (managePageWin) close();
    open();

    isWindowFocused = false;
    Util.addEvent(window, 'focus', onFocus);
  });

  core.on('startApp', (apps) => {
    if (!Array.isArray(apps)) {
      apps = [apps];
    }

    // If we're still starting an app let's just add ourselves to the queue
    if (startingApp) {
      appQueue.push(...apps);
      return;
    }

    const app = apps.shift();
    let opts = {};
    let appId = typeof app === 'object' ? app.app : app;

    if (['control', 'login'].indexOf(appId) === -1 && sumoMode !== CLIENT_MODES.MANAGE) {
      core.emit('openManagePage', { sumopath: app });

      // Wordpress stuff: Remove the dimmed overlay
      const overlayEl = document.querySelector('.sumome-logged-in-container-overlay.dim');
      if (overlayEl) {
        overlayEl.classList.remove('dim');
      }

      return;
    }

    if (typeof app === 'object') {
      opts = app.opts || {};
      appId = app.app;
    }

    appQueue.push(...apps);

    // Make sure we're logged in before launching apps
    // Check sessionId as well since user may be null during async initialization
    // Don't start login app in MANAGE mode if user has sessionId (manage page handles itself)
    const isLoggedIn = sumoProperties.user || sumoProperties.sessionId;
    const isManageMode = sumoMode === CLIENT_MODES.MANAGE;
    
    if (!isLoggedIn && appId !== 'login') {
      appQueue.unshift(app);

      if (sumoBadge) {
        sumoBadge.triggerHandler('click');
      } else {
        core.emit('startApp', 'login');
      }
      return;
    }
    
    // If login app is requested but user is already logged in and we're in manage mode,
    // don't start it - the manage page/launcher handles authentication
    if (appId === 'login' && isLoggedIn && isManageMode) {
      return;
    }

    // Blocks direct app_store requests from non-admins.  Users have to have admin
    // permissions to add and remove apps.
    if (appId === 'app_store' && sumoProperties.access !== 'admin') {
      console.log('Blocked access to the store from non-admin');
      appId = 'launcher';
    }

    if (opts.importSource === 'list-builder') {
      // Install LB3, then open it
      installApp(appId, (err) => {
        // If there is an error, show error and do nothing.
        // if (err) return $.growlUI(err, null, 2000, () => { });

        core.emit(`installed-${appId}`);
        startApp(appId, opts);
      });

      return;
    }

    /**
     * Prevents "cannot start module" error when clicking control header icons in manage mode multiple times
     * onClose function from closing app causes sumome-modal-mask to be removed and error prevents launching the "restoreApp"
     */
    if (!(currentApp === appId && sumoMode === CLIENT_MODES.MANAGE && (appId === 'ee27a0af-9947-40c9-8eab-0ab6a4f7a9c1' || appId === SETTINGS_APP_ID))) {
      startApp(appId, opts);
    }
  });

  core.on('setProperties', (props) => {
    Object.assign(sumoProperties, props);
  });

  core.on('removeCookie', (cookie) => {
    jscookie.remove(cookie, { path: '/' });
  });

  core.on('event', (event) => {
    const params = new URLSearchParams({
      site_id: siteId,
      app_id: event.appId,
      shortcut_id: event.shortcutId,
      visitor_id: sumoProperties.visitorId,
      event: event.event,
      href: event.href || window.location.href || null,
      ref: document.referrer || null,
      cache: Math.random(),
    }).toString();
    const src = `${apiUrl}/api/event/?${params}`;
    // append tracking image
    const img = document.createElement('img');
    img.setAttribute('src', src);
    img.setAttribute('alt', '');
    img.style.display = 'none';

    document.body.appendChild(img);
  });

  core.on('restartApp', (moduleId) => {
    if (currentApp === moduleId.split('/')[0]) { currentApp = null; }
    core.stop(`${moduleId}/app`, (err) => {
      if (!err) {
        console.info(`${moduleId} WAS STOPPED`);

        if (moduleId === 'launcher') {
          launcherLaunched = false;
        }

        core.emit('startApp', moduleId);
      } else {
        console.log(`Error: ${err}`);
      }
    });
  });

  core.on('stop', (moduleId) => {
    if (currentApp === moduleId.split('/')[0]) currentApp = null;

    core.stop(moduleId, (err) => {
      if (!err) {
        window.location.hash = '';
        console.info(`${moduleId} WAS STOPPED`);
        core.emit(`${moduleId}/stopped`, moduleId);

        if (moduleId === 'launcher/app') {
          launcherLaunched = false;
        }
      } else {
        console.log(`Error: ${err}`);
      }
    });
  });

  core.on('purchase', (data) => {
    if (!jscookie.get('__smToken')) {
      if (data.done) {
        data.done({ success: false, error: 'Please log back in' });
      }
      return core.emit('logout', false);
    }

    const iSrc = data.iSrc || jscookie.get('__smIRef') || null;
    const src = data.src || jscookie.get('__smSrc') || null;
    const siteId = data.siteId;
    const cartId = data.cartId;
    const productId = data.productId;
    const couponCode = data.couponCode || null;
    const collectionId = data.collectionId || null;
    const expiresAt = data.expiresAt || null;
    const done = data.done;
    const onWindowClose = data.onWindowClose;
    const w = 400;
    const h = 670;
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
    let checkoutDone = false;

    if (!siteId) {
      window.location.href = `${apiUrl}/billing`;
      return;
    }

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    const left = ((width / 2) - (w / 2)) + dualScreenLeft;
    const top = ((height / 2) - (h / 2)) + dualScreenTop;
    let url = `${sumoProperties.secureSumoUrl}/site/${siteId}/store/product/${productId}/`;

    const platform = Util.getQueryVariable('payment_processor');
    const params = [];

    if (couponCode) {
      // apply promotion discount id
      params.push({ key: 'promotion', val: couponCode });
    }

    if (platform) {
      // apply payment procesor
      params.push({ key: 'payment_processor', val: platform });
    }

    if (iSrc) {
      params.push({ key: 'i_src', val: iSrc });
    }

    if (params.length) {
      for (let i = 0; i < params.length; i += 1) {
        url += (i === 0 ? '?' : '&');
        url = `${url + params[i].key}=${params[i].val}`;
      }
    }

    const newWindow = window.open(url, '_blank', `width=${w}, height=${h}, top=${top}, left=${left}`);
    if (window.focus) {
      newWindow.focus();
    }

    if (onWindowClose) {
      let cartTimer;

      const pollTimer = window.setInterval(() => {
        if (newWindow.closed !== false && !checkoutDone) {
          checkoutDone = true;
          window.clearInterval(pollTimer);
          window.clearInterval(cartTimer);
          onWindowClose({ cartId, productId, expiresAt });
        } else if (checkoutDone) {
          window.clearInterval(pollTimer);
          window.clearInterval(cartTimer);
        }
      }, 500);

      cartTimer = window.setInterval(() => {
        apiFetch(`${sumoProperties.sumoUrl}/api/cart/checkcart`, {
          ...postData,
          body: JSON.stringify({ site_id: sumoProperties.siteId, cart_id: cartId })
        })
          .then(response => response.json())
          .then(data => {
            if (data.done && !checkoutDone) {
              checkoutDone = true;
              window.clearInterval(pollTimer);
              window.clearInterval(cartTimer);
              onWindowClose({ cartId, productId });
            } else if (checkoutDone) {
              window.clearInterval(pollTimer);
              window.clearInterval(cartTimer);
            }
          })
          .catch(error => console.error('Error:', error));
      }, 20000);


      setTimeout(() => {
        window.clearInterval(pollTimer);
        window.clearInterval(cartTimer);
      }, 1200000);
    }

    apiFetch(`${sumoProperties.secureSumoUrl}/api/app_store/purchase`, {
      ...postData,
      body: JSON.stringify({
        site_id: sumoProperties.siteId,
        cart_id: cartId,
        product_id: productId,
        src,
        i_src: iSrc,
        collection_id: collectionId,
        promotion: couponCode,
      })
    })
    .then(response => response.json())
    .then(data => {
      if (done) {
        done(data);
      }
    })
    .catch(error => console.error('Error:', error));
  });

  core.on('beforeLogin', (deferred) => {
    if (sumoBadge) {
      sumoBadge.style('display', 'none', 'important');
      sumoBadge.off('click');
      sumoBadge.remove();
      sumoBadge = null;
    }

    // Temporary hack to patch up platform plugins
    document.querySelectorAll('[class^=sumome-] [class*=-dash-logged-in]')
      .forEach(el => {
        el.classList.remove('status-logged-out');
        el.classList.add('status-logged-in');
      });

    document.querySelectorAll('[class^=sumome-] [class*=-dash-logged-out]')
      .forEach(el => {
        el.classList.remove('status-logged-out');
        el.classList.add('status-logged-in');
      });


    if (deferred) {
      setTimeout(() => {
        core.emit('login');
      }, 10000);
    } else {
      core.emit('login');
    }
  });

  core.on('logout', (soft) => {
    if (soft !== false) soft = true;

    // stop any apps
    if (currentApp) {
      core.emit('stop', `${currentApp}/app`);
    }
    // stop control
    core.emit('stop', 'control/app');

    softLogin = soft;

    // logout via POST because only the server can delete the __smSession cookie (httpOnly)
    apiFetch(`${apiUrl}/api/logout`, {
      body: JSON.stringify({ site_id: siteId, soft })
    })
    .catch(error => console.error('Error:', error));

    if (!soft) {
      // remove cookies
      core.emit('removeCookie', '__smToken');
      core.emit('removeCookie', '__smUser');
      core.emit('setProperties', { user: null, sessionId: null, access: null });
    }

    // reinstall badge
    installSiteBadge();
  });

  /**
   * are we installed?
   *   yes: auto run services
   *   no: run register app
   */
  const loadSumoMe = () => {
    if (window.__smLoaded) {
      if (document.querySelectorAll('.multiple-sumome-warning-toast').length === 0) {
        console.warn('More than one instance of Sumo is attempting to start...');

        let toastEl = document.createElement('div');
        toastEl.className = 'multiple-sumome-warning-toast sumome-doctype-notice';

        toastEl.textContent = 'More than one instance of Sumo is attempting to start on this page. Please check that you are only loading Sumo once per page.';

        let spanEl = document.createElement('span');
        spanEl.className = 'sumome-doctype-notice-close';

        spanEl.addEventListener('click', function() {
          toastEl.remove();
        });

        toastEl.appendChild(spanEl);

        document.body.appendChild(toastEl);
      }

      return false;
    }

    loaded = true;
    window.__smLoaded = true;

    // Try to parse shopify utm params, but don't crash sumo doing it
    try {
      ShopifyUtil.processShopifyParams();
    } catch (err) { /* noop */ }

    // Try to auto-apply any discounts in the query params
    try {
      ShopifyUtil.autoApplyDiscounts();
    } catch (err) { /* noop */ }
    // Check if we have a shopify email to log
    // Disabled 6/19/19
    // ShopifyUtil.logExistingUserAsSubscriber({ visitorId, siteId, sumoUrl });

    window.addEventListener('resize', function() {
      core.emit('resize');
    });

    if (window.addEventListener) {
      window.addEventListener('sumome', (e) => {
        if (e && e.detail && e.detail.type === 'launch') {
          if (sumoBadge) {
            sumoBadge.triggerHandler('click');
          } else {
            core.emit('startApp', 'launcher');
          }
        }
      });
    }

    if ('location' in window && 'search' in window.location && window.location.search.indexOf('smdebug') >= 0) {
      window.__smDebug = true;
      window.__smArticles = Articles;
    }

    const bodyData = {
      href: window.location.href || null,
      ref: document.referrer || null,
    };

    if (siteId) {
      bodyData.site_id = siteId;
    } else if (sumoMode === CLIENT_MODES.MANAGE) {
      startApp('site-select');
      return;
    }

    if (visitorId) bodyData.visitor_id = visitorId;

    if (sumoMode) bodyData.mode = sumoMode;

    if (sumoPlatform) bodyData.platform = sumoPlatform;

    const loadScriptEls = [].slice.apply(document.querySelectorAll('script')).filter((el) => (
      el.src.includes('load.sumo.com')
      || el.src.includes('load.sumome.com')
      || el.getAttribute('data-sumo-site-id')
    ));

    if (loadScriptEls?.length > 0) {
      bodyData.loadScriptSource = loadScriptEls[0].src;
    }

    // magic token
    const magicToken = Util.getQueryVariable('sumotoken');
    const headers = magicToken
      ? { 'X-Sumo-Token': magicToken }
      : null;
    apiFetch(`${apiUrl}/api/load/`, {
      headers,
      body: JSON.stringify(bodyData),
    })
    .catch((e) => {
      core.emit('removeCookie', '__smUser');
      console.error(e);
    })
    .then(async (data) => {
      const hint = false;
      const isValidData = data && typeof data === 'object' && !Array.isArray(data);

      if (isValidData) {
        const validProps = [
          'hint', 'siteId', 'siteRegistered', 'badgeLocation', 'unreadNotificationCount',
          'hasSumoMePro', 'access', 'geoLocation', 'ipAddress', 'views', 'tours',
          'clientSites', 'gravatarHash', 'promptedShopifyReview', 'activatedAt', 'platform',
          'services', 'isShopifyBilling', 'siteName', 'siteHref',
        ];

        for (let i = 0; i < validProps.length; i += 1) {
          if (validProps[i] in data) {
            sumoProperties[validProps[i]] = data[validProps[i]];
          }
        }

        if ('siteId' in data && data.siteId) {
          siteId = data.siteId;
        }

        if ('siteCreated' in data && data.siteCreated) {
          let iframe = document.createElement('iframe');
          iframe.setAttribute('id', 'sumome-iframe');
          iframe.setAttribute('src', `${sumoProperties.secureSumoUrl}/api/conversion/installed?site_id=${siteId}&platform=${sumoPlatform}&utm_nooverride=1`);
          iframe.setAttribute('style', 'width:0;height:0;border:0;background:transparent;padding:0;margin:0;');

          document.body.appendChild(iframe);
        }
      }

      sumoProperties.magicPassword = data && data.magicPassword;
      sumoProperties.loadScriptSource = data ? data.loadScriptSource : '';

      if (data?.success) {
        if ('token' in data && data.token) {
          sumoProperties.sessionId = data.token;
          // Set expires to one year from now
          const expireStr = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
          document.cookie = `__smToken=${data.token}; expires=${expireStr}; path=/; SameSite=None; Secure; Partitioned; Domain=${sumoProperties.domain}`;
        }

        if ('user' in data && data.user) {
          sumoProperties.user = data.user;
          sumoProperties.role = data.role;
          const expireStr = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
          document.cookie = `__smUser=${data.user}; expires=${expireStr}; path=/; SameSite=None; Secure; Partitioned; Domain=${sumoProperties.domain}`;

          if (sumoMode === CLIENT_MODES.MANAGE || ('login' in data && data.login) || data.unreadNotificationCount > 0) {
            // log us in!!!
            core.emit('beforeLogin', ('siteCreated' in data && data.siteCreated));
            if (sumoMode !== CLIENT_MODES.MANAGE || launcherLaunched) {
              core.emit('startApp', 'control');
            }
          } else {
            installSiteBadge();
          }

          core.emit('checkCompatibilityMode');
        } else {
          core.emit('removeCookie', '__smUser');
          installSiteBadge(hint);
        }

        if ('apps' in data) {
          sumoProperties.apps = data.apps;
        }

        if ('publicApps' in data) {
          sumoProperties.publicApps = data.publicApps;
        }

        // Start service(s) handler
        let useBundledServices = false; 
        let useListBuilder3Service = false;
        if (data.services?.length > 0) {
          for (let i = 0; i < data.services.length; i += 1) {
            if ([
              IMAGE_SHARER_APP_ID,
              SHARE_APP_ID,
            ].indexOf(data.services[i]) !== -1) {
              useBundledServices = true;
            }

            if (data.services[i] === '156085c5-0017-4150-b225-a731ad248f38') {
              useListBuilder3Service = true;
            }
          }
        }

        if (
          sumoMode !== CLIENT_MODES.MANAGE &&
          (
            useListBuilder3Service
            || useBundledServices
          )
        ) {
          const query = queryStringParser(window.location.search) || {};
          const serviceReqBody = {
            site_id: sumoProperties.siteId,
            location: window.location.toString().toLowerCase(),
            geoLocation: sumoProperties.geoLocation,
            pageViews: sumoProperties.views,
            referrer: document.referrer,
            cookie_names: Object.keys(jscookie.get()),
            articles: Articles.findAll().length,
            userAgent: navigator.userAgent,
            width: Math.min(window.screen.availWidth || window.innerWidth, window.innerWidth),
          };

          if ('sumo_preview' in query) {
            serviceReqBody.is_preview = true;
          }

          // NOTE: not sure if this is still needed.  8dcxxx is a legacy app, so I suspect we can
          // drop this block
          if (data.services?.indexOf('8dc42610-ae42-4164-90b1-573478b46574') >= 0) {
            serviceReqBody.listBuilderService = true;

            // Find possible embed codes
            const embedCodeIds = [];
            document.querySelectorAll('[data-sumome-listbuilder-embed-id]').forEach((el) => {
              embedCodeIds.push(el.getAttribute('data-sumome-listbuilder-embed-id'));
            });

            serviceReqBody.embed_code_ids = embedCodeIds;
          }

          if (useListBuilder3Service) {
            serviceReqBody.listBuilder3Service = true;
            serviceReqBody.embedCodeIds = EmbeddedUtil.getManuallyEmbeddedIds();
          }

          if (data.services?.indexOf(IMAGE_SHARER_APP_ID) >= 0) {
            serviceReqBody.imageSharerService = true;
          }

          if (data.services?.indexOf(SHARE_APP_ID) >= 0) {
            let currentUri = null;
            const url = (document.querySelector('meta[property="og:url"]')?.content)
              || (document.querySelector('link[rel="canonical"]')?.href)
              || window.location.href.split('#')[0]
              || null;

            if (url) {
              const uri = URI(url);
              if (uri.is('absolute')) {
                currentUri = uri.toString();
              } else {
                currentUri = uri.absoluteTo(window.location.href.split('#')[0]).toString();
              }
            } else {
              currentUri = url;
            }

            let articles = Array.from(Articles.findAll());
            if (articles.length > 1) articles = [];

            const urls = [];
            articles.forEach((el) => {
              if(el.__url) urls.push(el.__url);
            });

            serviceReqBody.shareService = true;
            serviceReqBody.href = currentUri;
            serviceReqBody.urls = urls;
          }

          apiFetch(`${sumoProperties.sumoUrl}/services`, {
            body: JSON.stringify(serviceReqBody),
          })
            .then((serviceData) => {
              sumoProperties.serviceData = serviceData;

              if (useListBuilder3Service) {
                core.emit('startService', '156085c5-0017-4150-b225-a731ad248f38');
              }

              if (useBundledServices) {
                sumo.require(['services/index'], (module) => {
                  core.register('services/index', module);
                  core.start('services/index', () => {});
                });
              }
            })
            .catch(error => console.log('error', error));
        }

        if (!softLogin) {
          if (data.widgets?.length > 0) { 
            for (let i = 0; i < data.widgets.length; i += 1) {
              core.emit('startWidget', data.widgets[i]);
            }
          }
        } else {
          deferredWidgets = data.widgets;
        }

        if (sumoMode === CLIENT_MODES.MANAGE) {
          const { init } = await import(/* webpackChunkName: "manage" */ './manage');

          init(core);
        }
      } else {
        core.emit('removeCookie', '__smUser');
        installSiteBadge();
      }

      let sumoPath = Util.getQueryVariable('sumopath');

      if (sumoMode !== CLIENT_MODES.MANAGE && sumoPath) {
        try {
          const decodedPath = base64url.decode(sumoPath);
          sumoPath = decodedPath && decodedPath.indexOf('/') === 0 ? decodedPath : sumoPath;
          core.emit('openManagePage', { sumopath: sumoPath });
        } catch (e) { /* noop */ }
      }
    });
  };

  const started = new Date();
  const loadTimeout = 3000;

  function sumoMeReadyCheck() {
    if (loaded) return;

    if (['complete', 'interactive'].includes(document.readyState)) {
      return loadSumoMe();
    }

    try {
      if ((new Date()) - started >= loadTimeout && document.body) return loadSumoMe();
    } catch (e) { /* noop */ }

    setTimeout(sumoMeReadyCheck, 10);
  }

  document.addEventListener('DOMContentLoaded', function() {
    if (!loaded) loadSumoMe();
  });

  sumoMeReadyCheck();

  return core;
});
